import { render, staticRenderFns } from "./RestrictedAreas.vue?vue&type=template&id=79831ae2&scoped=true"
import script from "./RestrictedAreas.vue?vue&type=script&lang=js"
export * from "./RestrictedAreas.vue?vue&type=script&lang=js"
import style0 from "./RestrictedAreas.vue?vue&type=style&index=0&id=79831ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79831ae2",
  null
  
)

export default component.exports